<script setup lang="ts">
import {
  PhCamera,
  PhCaretLeft,
  PhCaretRight,
  PhDevices,
  PhEnvelopeSimple,
  PhPencilSimple,
  PhSignOut,
  PhWechatLogo,
} from "@phosphor-icons/vue";
</script>

<template>
  <section id="accountView" class="account-view" aria-labelledby="accountViewTitle" hidden>
    <header class="view-header">
      <button id="accountBackButton" class="icon-button" type="button" aria-label="返回素材总览">
        <PhCaretLeft :size="18" weight="bold" aria-hidden="true" />
      </button>
      <div class="view-title-group">
        <h2 id="accountViewTitle">账号设置</h2>
        <span>资料与账号绑定</span>
      </div>
    </header>

    <div class="account-scroll">
      <section class="account-identity" aria-label="当前账号">
        <div class="account-avatar-control">
          <span id="accountAvatar" class="account-avatar account-avatar--large" aria-hidden="true">A</span>
          <button type="button" aria-label="修改头像" title="头像功能暂未开放" disabled>
            <PhCamera :size="12" weight="bold" aria-hidden="true" />
          </button>
        </div>
        <div>
          <strong id="accountNickname">—</strong>
          <span id="accountEmail">—</span>
        </div>
      </section>

      <section class="account-settings-list" aria-label="账号资料">
        <button class="account-setting-row" type="button" disabled title="昵称功能暂未开放">
          <PhPencilSimple :size="17" weight="bold" aria-hidden="true" />
          <span>昵称</span>
          <strong id="accountNicknameValue">—</strong>
          <small>待开放</small>
        </button>
        <div class="account-setting-row">
          <PhEnvelopeSimple :size="17" weight="bold" aria-hidden="true" />
          <span>邮箱</span>
          <strong id="accountBoundEmail">—</strong>
          <small class="account-binding-state account-binding-state--active">已绑定</small>
        </div>
        <button class="account-setting-row" type="button" disabled title="微信绑定暂未开放">
          <PhWechatLogo :size="17" weight="bold" aria-hidden="true" />
          <span>微信</span>
          <strong>未绑定</strong>
          <small>待开放</small>
        </button>
        <button id="deviceManagementButton" class="account-setting-row account-setting-row--link" type="button">
          <PhDevices :size="17" weight="bold" aria-hidden="true" />
          <span>设备管理</span>
          <PhCaretRight class="account-setting-chevron" :size="15" weight="bold" aria-hidden="true" />
        </button>
      </section>

      <button id="logoutButton" class="secondary-button logout-button" type="button">
        <span class="button-progress" aria-hidden="true"></span>
        <PhSignOut class="logout-button-icon" :size="17" weight="bold" aria-hidden="true" />
        <span>退出登录</span>
      </button>
    </div>
  </section>
</template>
